import type { IconData } from '@stacksjs/iconify-core'

export const thermometerSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23.402 1.505a38 38 0 0 1 1.195 0c2.298.036 4.204.982 5.54 2.523c1.317 1.518 2.02 3.538 2.118 5.682c.134 2.951.245 7.223.245 13.29q0 .944-.004 1.832A12.47 12.47 0 0 1 36.5 34c0 6.904-5.597 12.5-12.5 12.5c-6.904 0-12.5-5.596-12.5-12.5a12.47 12.47 0 0 1 4.003-9.168Q15.5 23.945 15.5 23c0-6.067.11-10.339.245-13.29c.097-2.144.8-4.164 2.116-5.682c1.337-1.54 3.244-2.487 5.541-2.523M26 29.968V10a2 2 0 0 0-4 0v19.968a4.5 4.5 0 1 0 4 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default thermometerSolid
